﻿import {ativaAtualizacao, desativaAtualizacao} from "./default";
import {avisoAguarde, JsonStrToDate, retirarAguarde, tratarErro} from "./utils";
import {initLive} from "./live";

window.ConsultarJogos = function (id) {
  if (id == -5) {
    if (window.config.aovivo_no_nordeste) {
      window.location.href = url + "home/nordeste#/jogos?status=live";
      return;
    }
    $("#grdJogosLive").show();
    $("#grdJogos").hide();
    desativaAtualizacao();
    initLive();
    return;
  } else {
    if (!intervaloAtualizacao) {
      ativaAtualizacao();
    }
    $("#grdJogosLive").hide();
    $("#grdJogos").show();
  }

  if (id != -4) {
    window.lastFiltro = id + "?esporte=" + localStorage.EsporteId;
  }

  avisoAguarde();

  // filtro += " and (camp_jog_id eq 9155) ";
  //lastFiltro = "?esporte=" + localStorage.EsporteId;

  $.ajax({
    url: url + "enet/CampJogos/" + window.lastFiltro,
    type: "GET",
    contentType: "application/json; charset=utf-8",
    dataType: "json",
    processdata: true,
    success: function (data) {
      MontarGrade(data);
      retirarAguarde();
      if (id < 0) {
        window.ConsultarCamp && window.ConsultarCamp();
      }
    },
    error: function (xhr) {
      retirarAguarde();
      return null;
    }
  });
}

let listaJogos = [];

function MontarGradeInd(data) {
  divJogos.html("");

  let table = "<table border='0' cellpadding='2' cellspacing='2' width='100%' style='font-size:12px;'>{0}</table>";

  let row = "<tr {class}><td>{id}</td><td>{dataEvento}</td><td>{descEvento}</td>";

  let row2 = "";
  let linhas = "";

  if (localStorage.EsporteId === '101') {
    row2 = "<tr {class}><td>{desc}</td><td align='right'>{lb99001}</td><td align='right'>{lb99002}</td><td align='right'>{lb99003}</td><td align='right'>{lb99004}</td><td align='right'>{lb99005}</td></tr>";
    linhas = row2.replace("{desc}", "Participante").replace("{lb99001}",
      "1º").replace("{lb99001}", "1º")
      .replace("{lb99002}", "1º -2.5").replace("{lb99003}", "Até 3º")
      .replace("{lb99004}", "Até 5º").replace("{lb99005}", "Até 10º")
      .replace("{class}", "class='tabelaCabRod2'");
  } else if (localStorage.EsporteId === '102') {
    row2 = "<tr {class}><td>{desc}</td><td align='right'>{lb99101}</td></tr>";
    linhas = row2.replace("{desc}", "Participante").replace("{lb99101}",
      "1º").replace("{lb99101}", "1º").replace("{class}",
      "class='tabelaCabRod2'");
  }

  let campid = 0;

  let descricao = "";

  listaJogos = data;

  if (listaJogos.length > 0) {

    for (let i = 0; i < listaJogos.length; i++) {
      let dtHrIni = JsonStrToDate(listaJogos[i].DT_INI);

      if (campid !== listaJogos[i].CAMP_ID
        || descricao !== listaJogos[i].DESCRICAO) {
        linhas += "<tr class='subtitulotabela'><td colspan='6'>"
          + listaJogos[i].CAMP_NOME + " - "
          + listaJogos[i].DESCRICAO + ' - '
          + dtHrIni.toLocaleDateString("pt-BR", {
            day: '2-digit',
            month: '2-digit',
            year: '2-digit',
            hour: '2-digit',
            minute: '2-digit'
          }) + "</td></tr>";

        campid = listaJogos[i].CAMP_ID;
        descricao = listaJogos[i].DESCRICAO;
      }
      let css;

      for (let p = 0; p < listaJogos[i].PARTICIPANTES.length; p++) {
        if (p % 2 === 0)
          css = "class='tabelaLinhaImpar2'";
        else
          css = "class='tabelaLinhaPar2'";

        let vl1 = "&nbsp;";
        let vl2 = "&nbsp;";
        let vl3 = "&nbsp;";
        let vl4 = "&nbsp;";
        let vl5 = "&nbsp;";

        if (localStorage.EsporteId === '101') {
          for (let j = 0; j < listaJogos[i].PARTICIPANTES[p].Odds.length; j++) {
            if (listaJogos[i].PARTICIPANTES[p].Odds[j].ODD_TIPO === 99001) {
              vl1 = "<a href='javascript:window.CheckOddLocal("
                + listaJogos[i].PARTICIPANTES[p].ID
                + ", "
                + listaJogos[i].PARTICIPANTES[p].Odds[j].ID
                + ")' data-jog-odd-id='" + listaJogos[i].PARTICIPANTES[p].Odds[j].ID + "'>"
                + (listaJogos[i].PARTICIPANTES[p].Odds[j].TAXA > 0 ? listaJogos[i].PARTICIPANTES[p].Odds[j].TAXA
                    .toLocaleString('pt-BR', {
                      minimumFractionDigits: '2',
                      maximumFractionDigits: '2'
                    })
                  : "") + "</a>";
            } else if (listaJogos[i].PARTICIPANTES[p].Odds[j].ODD_TIPO === 99002) {
              vl2 = "<a href='javascript:window.CheckOddLocal("
                + listaJogos[i].PARTICIPANTES[p].ID
                + ", "
                + listaJogos[i].PARTICIPANTES[p].Odds[j].ID
                + ")' data-jog-odd-id='" + listaJogos[i].PARTICIPANTES[p].Odds[j].ID + "'>"
                + (listaJogos[i].PARTICIPANTES[p].Odds[j].TAXA > 0 ? listaJogos[i].PARTICIPANTES[p].Odds[j].TAXA
                    .toLocaleString('pt-BR', {
                      minimumFractionDigits: '2',
                      maximumFractionDigits: '2'
                    })
                  : "") + "</a>";
            } else if (listaJogos[i].PARTICIPANTES[p].Odds[j].ODD_TIPO === 99003) {
              vl3 = "<a href='javascript:window.CheckOddLocal("
                + listaJogos[i].PARTICIPANTES[p].ID
                + ", "
                + listaJogos[i].PARTICIPANTES[p].Odds[j].ID
                + ")' data-jog-odd-id='" + listaJogos[i].PARTICIPANTES[p].Odds[j].ID + "'>"
                + (listaJogos[i].PARTICIPANTES[p].Odds[j].TAXA > 0 ? listaJogos[i].PARTICIPANTES[p].Odds[j].TAXA
                    .toLocaleString('pt-BR', {
                      minimumFractionDigits: '2',
                      maximumFractionDigits: '2'
                    })
                  : "") + "</a>";
            } else if (listaJogos[i].PARTICIPANTES[p].Odds[j].ODD_TIPO === 99004) {
              vl4 = "<a href='javascript:window.CheckOddLocal("
                + listaJogos[i].PARTICIPANTES[p].ID
                + ", "
                + listaJogos[i].PARTICIPANTES[p].Odds[j].ID
                + ")' data-jog-odd-id='" + listaJogos[i].PARTICIPANTES[p].Odds[j].ID + "'>"
                + (listaJogos[i].PARTICIPANTES[p].Odds[j].TAXA > 0 ? listaJogos[i].PARTICIPANTES[p].Odds[j].TAXA
                    .toLocaleString('pt-BR', {
                      minimumFractionDigits: '2',
                      maximumFractionDigits: '2'
                    })
                  : "") + "</a>";
            } else if (listaJogos[i].PARTICIPANTES[p].Odds[j].ODD_TIPO === 99005) {
              vl5 = "<a href='javascript:window.CheckOddLocal("
                + listaJogos[i].PARTICIPANTES[p].ID
                + ", "
                + listaJogos[i].PARTICIPANTES[p].Odds[j].ID
                + ")' data-jog-odd-id='" + listaJogos[i].PARTICIPANTES[p].Odds[j].ID + "'>"
                + (listaJogos[i].PARTICIPANTES[p].Odds[j].TAXA > 0 ? listaJogos[i].PARTICIPANTES[p].Odds[j].TAXA
                    .toLocaleString('pt-BR', {
                      minimumFractionDigits: '2',
                      maximumFractionDigits: '2'
                    })
                  : "") + "</a>";
            }
          }

          linhas += row2.replace("{desc}",
            listaJogos[i].PARTICIPANTES[p].TIME_NOME).replace(
            "{lb99001}", vl1).replace("{lb99002}", vl2)
            .replace("{lb99003}", vl3)
            .replace("{lb99004}", vl4)
            .replace("{lb99005}", vl5).replace("{class}", css);
        } else if (localStorage.EsporteId === '102') {
          for (let j = 0; j < listaJogos[i].PARTICIPANTES[p].Odds.length; j++) {
            if (listaJogos[i].PARTICIPANTES[p].Odds[j].ODD_TIPO === 99101) {
              vl1 = "<a href='javascript:window.CheckOddLocal2("
                + listaJogos[i].PARTICIPANTES[p].ID
                + ", "
                + listaJogos[i].PARTICIPANTES[p].Odds[j].ID
                + ")' data-jog-odd-id='" + listaJogos[i].PARTICIPANTES[p].Odds[j].ID + "'>"
                + (listaJogos[i].PARTICIPANTES[p].Odds[j].TAXA > 0 ? listaJogos[i].PARTICIPANTES[p].Odds[j].TAXA
                    .toLocaleString('pt-BR', {
                      minimumFractionDigits: '2',
                      maximumFractionDigits: '2'
                    })
                  : "") + "</a>";
            }
          }

          linhas += row2.replace("{desc}",
            listaJogos[i].PARTICIPANTES[p].TIME_NOME).replace(
            "{lb99101}", vl1).replace("{class}", css);
        }

      }
    }
  } else {
    linhas += row.replace("{dataEvento}", "Nenhum registro encontrado")
      .replace("{id}", "").replace("{class}", "");
  }

  table = table.replace("{0}", linhas);

  divJogos.append(table + "<br /><br />");
  AtualizarOddsAtivas();
}

function MontarGrade(data) {
  divJogos.html("");

  listaJogos = data;

  /*
   * for (i = 0; i < data.length; i++) { if (data[i].Odds.length > 0) {
   * listaJogos.push(data[i]); } }
   */


  let table = "<table border='0' class='tableFixHead' cellpadding='2' cellspacing='2' width='100%' style='font-size: Small;'>{1}<tbody >{0}</tbody></table>";

  // row = "<tr {class}><td>{times}</td><td width='55px'
  // align='center'>{casa}</td><td width='55px' align='center'>{emp}</td><td
  // width='55px' align='center'>{fora}</td><td
  // width='25px'>{mais}</td></tr>";

  let headerrow = "<thead {class}><td>{times}</td>{cotacoes}<td width='25px'>{mais}</td></thead>";
  let row = "<tr {class}><td style='width: 100%;'>{times}</td>{cotacoes}<td width='25px'>{mais}</td></tr>";

  var linhas = "";

  var campid = 0;

  var colSpan = 2;

  var txtCotacoes = "";
  var linhaCab = "";

  var txt = "";

  var tipos = [];

  if (listaJogos.length > 0) {
    var qtdOdds = 0;

    for (let i = 0; i < listaJogos.length; i++) {
      var Odds = listaJogos[i].Odds;

      if (Odds.length > qtdOdds) {
        txtCotacoes = "";
        linhaCab = "";

        for (let x = 0; x < Odds.length; x++) {
          txtCotacoes += "<td width='40px' align='center'>{"
            + Odds[x].odd_tipo + "}</td>";

          linhaCab += "<td width='40px' align='center'>"
            + Odds[x].descricao + "</td>";

          tipos.push(Odds[x].odd_tipo);
          //console.log(Odds, x)
          colSpan++;
        }

        qtdOdds = Odds.length;
      }
    }
  }

  for (let i = 0; i < listaJogos.length; i++) {
    let Odds = listaJogos[i].Odds;
    let css;
    if (i === 0) {
      txt = txtCotacoes;
      for (let x = 0; x < Odds.length; x++) {
        // txtCotacoes += "<td align='center'>" + Odds[x].descricao +
        // "</td>"

        txt = txt.replace("{" + Odds[x].odd_tipo + "}",
          Odds[x].descricao);
        // colSpan++;
      }
      linhas = headerrow.replace("{class}", "id='header' style='color: #fff;'")
        .replace("{times}", "Casa x Visitante<br />Data - Hora")
        .replace("{cotacoes}", linhaCab).replace("{mais}", "&nbsp");
      table = table.replace("{1}", linhas)
      linhas = ''
    }


    if (campid !== listaJogos[i].camp_id) {
      linhas += "<tr class='subtitulotabela'><td colspan='" + colSpan
        + "'>" + listaJogos[i].camp_nome + "</td></tr>";

      campid = listaJogos[i].camp_id;
    }

    if (i % 2 === 0)
      css = "class='tabelaLinhaImpar2'";
    else
      css = "class='tabelaLinhaPar2'";

    var d = JsonStrToDate(listaJogos[i].dt_hr_ini);

    d.setHours(d.getHours());

    var qtd = 0;

    txt = txtCotacoes;

    // var temPrin = false;
    // var temCasa = false;
    // var temFora = false;

    for (let x = 0; x < Odds.length; x++) {

      var cotacao = Odds[x].taxa ? "<a href='javascript:window.CheckOddLocal("
        + listaJogos[i].camp_jog_id
        + ", "
        + Odds[x].jog_odd_id
        + ")' data-jog-odd-id='" + Odds[x].jog_odd_id + "'>"
        + (Odds[x].taxa > 1 ? Odds[x].taxa.toLocaleString('pt-BR',
          {
            minimumFractionDigits: '2',
            maximumFractionDigits: '2'
          }) : "") + "</a>" : "&nbsp;";

      txt = txt.replace("{" + Odds[x].odd_tipo + "}", "<b>" + cotacao
        + "</b></td>");

      qtd++;
    }

    for (let x = 0; x < tipos.length; x++) {
      const chave = "{" + tipos[x] + "}";
      txt = txt.replace(chave, "&nbsp;");
    }

    //if (qtd > 0) {
    if (window.config.enetimg === 0) {
      linhas += row.replace("{class}", css).replace(
        "{times}",
        "<b>" + listaJogos[i].casa_time + "</b> x <b>"
        + listaJogos[i].visit_time + "</b><br />"
        + d.toLocaleDateString("pt-BR", {
          day: '2-digit',
          month: '2-digit',
          year: '2-digit',
          hour: '2-digit',
          minute: '2-digit'
        })).replace("{cotacoes}", txt).replace(
        "{mais}",
        "<a href='javascript:window.MaisOdds(" + listaJogos[i].camp_jog_id
        + "," + listaJogos[i].esporte_id + ");'><i>+"
        + listaJogos[i].qtd_odds + "</i></a>");

    } else {
      linhas += row.replace("{class}", css).replace(
        "{times}",
        "<b>" + '<object data="https://assets.b365api.com/images/team/s/' + listaJogos[i].casa_time_img + '.png" type="image/png"><img src="/vue/img/t20.png" /></object>'
        + listaJogos[i].casa_time + "</b> x <b>"
        + listaJogos[i].visit_time +
        '<object data="https://assets.b365api.com/images/team/s/' + listaJogos[i].visit_time_img + '.png" type="image/png"><img src="/vue/img/t20.png" /></object>' +
        "</b><br />"
        + d.toLocaleDateString("pt-BR", {
          day: '2-digit',
          month: '2-digit',
          year: '2-digit',
          hour: '2-digit',
          minute: '2-digit'
        })).replace("{cotacoes}", txt).replace(
        "{mais}",
        "<a href='javascript:MaisOdds(" + listaJogos[i].camp_jog_id
        + "," + listaJogos[i].esporte_id + ");'><i>+"
        + listaJogos[i].qtd_odds + "</i></a>");
    }
    //}

  }

  divJogos.append(table.replace("{0}", linhas));
  AtualizarOddsAtivas();

  if (listaJogos.length === 0){
    divJogos.html("<div class='text-center'>Nenhum evento encontrado</div>");
  }
}

const SEM_ESCUDO = "/vue/img/t50.png";

function textoSeguro(valor) {
  return $("<div>").text(valor == null ? "" : valor).html();
}

function escudoLive(id) {
  const src = id ? "https://assets.b365api.com/images/team/m/" + parseInt(id, 10) + ".png" : SEM_ESCUDO;
  return "<img src='" + src + "' width='48' height='48' alt='' onerror=\"this.onerror=null;this.src='" + SEM_ESCUDO + "'\">";
}

function statLive(rotulo, v) {
  const casa = v ? v.casa : 0;
  const fora = v ? v.fora : 0;
  return "<div class='lh-stat'><div class='lh-linha'>"
    + "<b>" + (v ? casa : "–") + "</b><span>" + rotulo + "</span><b>" + (v ? fora : "–") + "</b></div>"
    + "<div class='lh-barra'>"
    + (casa ? "<i class='lh-casa' style='flex:" + casa + "'></i>" : "")
    + (fora ? "<i class='lh-fora' style='flex:" + fora + "'></i>" : "")
    + "</div></div>";
}

function cabecalhoLive(game) {
  const info = game.info;
  const pais = info.pais_completo || "Internacional";
  // O campeonato interno pode vir com o pais na frente ("Brasil - Serie A").
  const nome = info.league.name || "";
  const liga = nome.indexOf(pais + " - ") === 0 ? nome.slice(pais.length + 3) : nome;
  const gols = String(info.ss || "0-0").split("-");
  const minuto = Math.floor((parseInt(game.passed_seconds, 10) || 0) / 60);
  const s = game.stats;

  return "<div class='lh-liga'><strong>Futebol</strong> · " + textoSeguro(pais) + " — " + textoSeguro(liga) + "</div>"
    + "<div class='lh-placar'>"
    + "<div class='lh-casa-time'><span>" + textoSeguro(info.home.name) + "</span>" + escudoLive(info.home.img) + "</div>"
    + "<div class='lh-centro'><div class='lh-gols'>" + textoSeguro(gols[0]) + "<i>:</i><em>" + textoSeguro(gols[1]) + "</em></div>"
    + "<div class='lh-minuto'>" + minuto + "'</div></div>"
    + "<div class='lh-fora-time'>" + escudoLive(info.away.img) + "<span>" + textoSeguro(info.away.name) + "</span></div>"
    + "</div>"
    + (s ? "<div class='lh-stats'>"
      + statLive("Gols 1º tempo", s.ht)
      + statLive("Escanteios", s.cantos)
      + statLive("Cartões amarelos", s.amarelos)
      + statLive("Cartões vermelhos", s.vermelhos)
      + "</div>" : "");
}

// O poll do ao vivo chama a cada ciclo: so o cabecalho e redesenhado, porque
// refazer a tabela de odds perderia a rolagem de quem esta escolhendo o mercado.
window.AtualizarCabecalhoLive = function (lista) {
  const el = document.getElementById("liveHeader");
  if (!el) {
    return;
  }
  const id = el.getAttribute("data-id");
  const game = lista.find(function (j) {
    return String(j.info.id) === id;
  });
  if (game) {
    el.innerHTML = cabecalhoLive(game);
  }
};

function MontarMaisOdds(data, esporteId, liveGame) {
  maisOdds = data;
  betBuilderLegs = [];

  const bbCfg = window.config || {};
  const bbAtivo = !!bbCfg.bet_builder_ativo && esporteId === 1 && !liveGame;

  let table = "<table border='0' cellpadding='2' cellspacing='2' width='100%' style='font-size: Normal;'>"
    + "<thead><tr id='header' style='color: #fff;'><td style='min-width:300px;'>Descrição</td><td>Taxa</td></tr></thead>"
    + "<tbody>{0}</tbody></table>";

  let row = "<tr {class} data-jog-odd-id='{odd_id}' data-cat='{cat}'><td style='min-width:300px;'>{desc}</td><td>{taxa}</td></tr>";

  let linhas = "";
  let categId = 0;

  for (let i = 0; i < maisOdds.length; i++) {
    if (categId !== maisOdds[i].categoria_id && esporteId === 1) {
      // O selo "CA" é aplicado depois, por bbApplyBadges, a partir do que o
      // servidor disser que é elegível — o front não sabe mais quais grupos
      // participam do Criar Aposta.
      linhas += "<tr class='subtitulotabela' data-cat-header='" + maisOdds[i].categoria_id + "'><td colspan='2'>"
        + "<span class='bb-cat-desc'>" + maisOdds[i].categoria_desc + "</span>"
        + "</td></tr>";
      categId = maisOdds[i].categoria_id;
    }

    let css = i % 2 === 0 ? "class='tabelaLinhaImpar2'" : "class='tabelaLinhaPar2'";

    var descricao = maisOdds[i].descricao;
    var linhaDescricao;
    var linhaTaxa;

    if (liveGame) {
      window.liveGame = liveGame;
      linhaDescricao = "<a href='javascript:window.ConsultarOddLocalLive("
        + 0 + ", " + maisOdds[i].jog_odd_id + ");'>" + descricao + "</a>";
      linhaTaxa = "<a href='javascript:window.ConsultarOddLocalLive("
        + 0 + ", " + maisOdds[i].jog_odd_id + ");'>"
        + (maisOdds[i].taxa > 0 ? maisOdds[i].taxa.toLocaleString('pt-BR', {
            minimumFractionDigits: '2', maximumFractionDigits: '2'
          }) : "") + "</a>";
    } else {
      linhaDescricao = "<a href='javascript:window.CheckOdd2Local("
        + maisOdds[i].camp_jog_id + ", " + maisOdds[i].jog_odd_id + ");'>"
        + descricao + "</a>";
      linhaTaxa = "<a href='javascript:window.CheckOdd2Local("
        + maisOdds[i].camp_jog_id + ", " + maisOdds[i].jog_odd_id + ");'>"
        + (maisOdds[i].taxa > 0 ? maisOdds[i].taxa.toLocaleString('pt-BR', {
            minimumFractionDigits: '2', maximumFractionDigits: '2'
          }) : "") + "</a>";
    }

    linhas += row
      .replace("{class}", css)
      .replace("{odd_id}", maisOdds[i].jog_odd_id)
      .replace("{cat}", maisOdds[i].categoria_id)
      .replace("{desc}", linhaDescricao)
      .replace("{taxa}", linhaTaxa);
  }

  if (bbAtivo) {
    const scrollArea = "<div class='bb-scroll-area'>"
      + "<div id='bbHeader' class='bb-header'>"
      + "<div><strong>Criar Aposta</strong><br>"
      + "<small id='bbHeaderSub'>Criar Aposta desativado</small></div>"
      + "<label class='bb-toggle'>"
      + "<input type='checkbox' id='bbToggle' onchange='window.toggleBetBuilder()'>"
      + "<span class='bb-toggle-slider'></span></label></div>"
      + table.replace("{0}", linhas)
      + "</div>";
    const footer = "<div id='bbFooter' class='bb-footer' style='display:none;'>"
      + "<div id='bbLegsList'><em style='color:#999'>Selecione 2 a 4 odds</em></div>"
      + "<div class='bb-calc'>Odd combinada: <strong id='bbOddDisplay'>-</strong></div>"
      + "<button class='botao' id='bbAddBtn' onclick='window.adicionarBBaoBilhete()'"
      + " disabled style='width:100%;margin-top:8px'>Adicionar ao Bilhete</button></div>";
    $(".modalWindow2").addClass('bb-mode').html("<div class='bb-modal-wrap'>" + scrollArea + footer + "</div>");
  } else {
    const cabecalho = liveGame
      ? "<div id='liveHeader' class='live-header' data-id='" + textoSeguro(liveGame.info.id) + "'>" + cabecalhoLive(liveGame) + "</div>"
      : "";
    $(".modalWindow2").removeClass('bb-mode').html(cabecalho + table.replace("{0}", linhas));
  }
}

window.MaisOdds = function (id, esporteId, liveGame = null) {
  betBuilderMode = false;
  betBuilderLegs = [];
  betBuilderJogoId = id;
  betBuilderNomeTimes = '';

  for (let i = 0; i < listaJogos.length; i++) {
    if (listaJogos[i].camp_jog_id == id) {
      const d = JsonStrToDate(listaJogos[i].dt_hr_ini);
      betBuilderNomeTimes = "<b>" + listaJogos[i].casa_time + "</b> x <b>"
        + listaJogos[i].visit_time + "</b><br />"
        + d.toLocaleDateString("pt-BR", {
            day: '2-digit', month: '2-digit', year: '2-digit',
            hour: '2-digit', minute: '2-digit'
          });
      break;
    }
  }

  $(".modalWindow2, .modalBack").fadeIn('slow');
  $('body').addClass('noscroll');

  avisoAguarde();

  var live = !!liveGame === true ? 1 : 0;

  $.ajax({
    url: url + "enet/Odds/" + id + "/" + live,
    type: "GET",
    contentType: "application/json; charset=utf-8",
    dataType: "json",
    processdata: true,
    success: function (data) {
      var odds = Array.isArray(data) ? data : (data.odds || []);
      MontarMaisOdds(odds, esporteId, liveGame);
      // Pergunta ao servidor o que entra no Criar Aposta neste jogo. Serve ao
      // selo "CA" agora e deixa o estado pronto para quando o modo for ligado.
      bbResetState();
      if ((window.config || {}).bet_builder_ativo && esporteId === 1 && !liveGame) {
        bbRefresh(null, function () { /* sem BB: a tela de odds segue normal */ });
      }
      retirarAguarde();
    },
    error: function (xhr) {
      retirarAguarde();
      return null;
    }
  });
}

window.CashOut = function (id) {
  $(".modalCashout, .modalCashoutBack").fadeIn('slow');
  $('body').addClass('noscroll');
  avisoAguarde();

  $.ajax({
    url: url + "enet/cashout/" + id,
    type: "GET",
    success: function (data) {
      $(".modalCashout").html(data);
      retirarAguarde()
    },
    error: function (xhr) {
      retirarAguarde();
      return null;
    }
  });
}

window.ConfirmarCashOut = function (id) {
  var confirmacao = confirm("Deseja realmente realizar o CashOut do bilhete " + id + "?");
  if(!confirmacao) return;

  $(".modalCashout, .modalCashoutBack").fadeIn('slow');
  avisoAguarde();

  $.ajax({
    url: url + "enet/confirmarCashout/" + id,
    type: "GET",
    success: function (data) {
      $(".modalCashout").html(data);
      retirarAguarde()
    },
    error: function (xhr) {
      retirarAguarde();
      return null;
    }
  });
}

window.CheckOddLocal = function (campJogId, JogOddId) {
  ConsultarOddLocal(campJogId, JogOddId);
}

window.CheckOdd2Local = function (campJogId, JogOddId) {
  if (betBuilderMode) {
    selectBBLeg(JogOddId);
    return;
  }
  $(".modalWindow2, .modalBack").fadeOut('fast');
  $('body').removeClass('noscroll');
  ConsultarOddLocal(campJogId, JogOddId);
}

window.consultarBilhete = function (bilhete) {
  avisoAguarde();

  $("#target").load(url + "home/bilheteenet/" + encodeURI(bilhete) + "/1", retirarAguarde);
}

function CheckOddLocal2(campJogId, JogOddId) {
  localStorage.removeItem("bilhete");
  ConsultarOddLocal(campJogId, JogOddId);
}

var maisOdds;

// Bet Builder — o cliente não decide nada.
//
// Havia aqui uma cópia da allow-list de grupos, do mapa de dimensões e da
// checagem de pares. Era uma das seis reimplementações da mesma regra (três
// fronts, três apps), e elas divergiam: uma combinação existia no site e não
// existia no app. Agora quem decide é o BetBuilderEngine, no servidor, pelo
// endpoint enet/bbOpcoes — o MESMO código que valida o bilhete no fechamento.
//
// bbState guarda a última resposta: o que é elegível, o que está bloqueado dado
// o que já foi escolhido, e a odd combinada.
var bbState = {
  ativo: false,
  elegiveis: {},   // jog_odd_id => true
  bloqueadas: {},  // jog_odd_id => {motivo, texto}
  oddCombinada: 0,
  valido: false,
  minLegs: 2,
  maxLegs: 4,
  carregando: false
};

function bbResetState() {
  bbState = {
    ativo: false, elegiveis: {}, bloqueadas: {}, oddCombinada: 0,
    valido: false, minLegs: 2, maxLegs: 4, carregando: false
  };
}

// Consulta o servidor com as pernas atuais e redesenha. onErro recebe o
// controle quando a chamada falha: nunca liberamos por conta própria — sem
// resposta, o Criar Aposta não avança (o oposto de assumir que está tudo bem).
function bbRefresh(onOk, onErro) {
  bbState.carregando = true;
  $.ajax({
    url: url + "enet/bbOpcoes",
    type: "POST",
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify({
      jogo_id: betBuilderJogoId,
      legs: betBuilderLegs.map(function (l) { return l.jog_odd_id; })
    }),
    dataType: "json",
    success: function (r) {
      bbState.carregando = false;
      bbState.ativo = !!r.ativo;
      bbState.oddCombinada = parseFloat(r.odd_combinada) || 0;
      bbState.valido = !!r.valido;
      bbState.minLegs = r.min_legs || 2;
      bbState.maxLegs = r.max_legs || 4;

      bbState.elegiveis = {};
      (r.elegiveis || []).forEach(function (id) { bbState.elegiveis[id] = true; });
      bbState.bloqueadas = {};
      (r.bloqueadas || []).forEach(function (b) { bbState.bloqueadas[b.id] = b; });

      // Perna que saiu do ar entre dois toques (taxa caiu, mercado desativado):
      // o servidor devolve quais foram, e a seleção acompanha.
      if (r.legs_invalidas && r.legs_invalidas.length) {
        betBuilderLegs = betBuilderLegs.filter(function (l) {
          return r.legs_invalidas.indexOf(l.jog_odd_id) === -1;
        });
        if (r.mensagem) { alert(r.mensagem); }
      }

      bbApplyBadges();
      updateBBUI();
      if (onOk) { onOk(r); }
    },
    error: function () {
      bbState.carregando = false;
      if (onErro) { onErro(); }
      else { alert('Não foi possível validar a combinação. Tente novamente.'); }
    }
  });
}

// Marca com o selo "CA" as categorias que têm alguma odd aceita no Criar
// Aposta. Antes isso vinha de uma lista de grupos copiada do PHP; agora sai do
// próprio conjunto de elegíveis que o servidor devolveu.
function bbApplyBadges() {
  var comElegivel = {};
  (maisOdds || []).forEach(function (o) {
    if (bbState.elegiveis[o.jog_odd_id]) { comElegivel[o.categoria_id] = true; }
  });
  $('tr[data-cat-header]').each(function () {
    var cat = parseInt($(this).data('cat-header'));
    var $desc = $(this).find('.bb-cat-desc');
    $(this).find('.bb-badge').remove();
    if (comElegivel[cat] && $desc.length) { $desc.after(" <span class='bb-badge'>CA</span>"); }
  });
}

// Mostra só o que dá para escolher agora: a odd some se não é elegível ou se
// não combina com o que já está selecionado. A perna já escolhida continua
// visível para poder ser desmarcada.
function applyBBVisibility() {
  if (!betBuilderMode) {
    $('tr[data-cat], tr[data-cat-header]').show();
    return;
  }
  $('tr[data-jog-odd-id]').each(function () {
    var $row = $(this);
    var joid = parseInt($row.attr('data-jog-odd-id'));
    var selecionada = betBuilderLegs.some(function (l) { return l.jog_odd_id === joid; });
    $row.toggle(selecionada || (!!bbState.elegiveis[joid] && !bbState.bloqueadas[joid]));
  });
  // Cabeçalho de categoria só fica se sobrou alguma odd visível nela.
  $('tr[data-cat-header]').each(function () {
    var cat = parseInt($(this).data('cat-header'));
    $(this).toggle($('tr[data-jog-odd-id][data-cat="' + cat + '"]:visible').length > 0);
  });
}

var betBuilderMode = false;
var betBuilderLegs = [];
var betBuilderJogoId = 0;
var betBuilderNomeTimes = '';
window.liveGame = null;

window.RemoveOddLive = function (id) {
  var bilhete = PegaBilhete();
  for (var i = 0; i < bilhete.length; i++) {
    if (bilhete[i].camp_jog_id == id) {
      bilhete.splice(i, 1);
      localStorage.bilhete = JSON.stringify(bilhete);
      MontaBilhete();
      return;
    }
  }
}

window.ConsultarOddLocalLive = function (game, odd) {
  if(!game) {
    game = window.liveGame;
  }
  removeLive(false);
  var bilhete = PegaBilhete();

  for (var i = 0; i < bilhete.length; i++) {
    if (bilhete[i].camp_jog_id === game.info.rid) {
      var sameOdd = bilhete[i].jog_odd_id === odd;
      bilhete.splice(i, 1);
      localStorage.bilhete = JSON.stringify(bilhete);
      MontaBilhete();
      if (sameOdd) {
        return;
      }
    }
  }

  let jogoLocal = game;
  let nomes = "";

  if (jogoLocal !== undefined) {

    let idxOdd = -1;
    let Odds;

    let taxa = 0;
    nomes = "<b>" + jogoLocal.info.home.name + "</b> x <b>"
      + jogoLocal.info.away.name + "</b><br />"
      + jogoLocal.info.time;

    var descricao = "";
    switch (odd) {
      case '1':
        descricao = 'Casa';
        taxa = jogoLocal.ft.casa;
        break;
      case 'X':
        descricao = 'Empate';
        taxa = jogoLocal.ft.empate;
        break;
      case '2':
        descricao = 'Fora';
        taxa = jogoLocal.ft.fora;
        break;
      case '1X':
        descricao = 'Casa ou Empate';
        taxa = jogoLocal.dp.casaEmpate;
        break;
      case '12':
        descricao = 'Casa ou Fora';
        taxa = jogoLocal.dp.casaFora;
        break;
      case '2X':
        descricao = 'Fora ou Empate';
        taxa = jogoLocal.dp.empateFora;
        break;
      default:
        Odds = maisOdds;
        for (let i = 0; i < Odds.length; i++) {
          if (Odds[i].jog_odd_id === odd) {
            descricao = Odds[i].descricao;
            taxa = Odds[i].taxa;
            break;
          }
        }
    }

    taxa = parseFloat(taxa);
    taxa = taxa * (100 + window.config.aovivo_variancia) / 100;
    taxa = Math.min(taxa, window.config.aovivo_taxamaxima).toFixed(2);

    if (taxa <= 1) {
      return;
    }

    var jogo = {
      jog_odd_id: odd,
      esporte_id: localStorage.EsporteId,
      camp_jog_id: game.info.rid,
      descricao: descricao,
      taxa: taxa,
      nomeTimes: nomes,
      aovivo: true
    };

    let idx = PegaIndexOddPorCampJogId(game.info.id);

    var bilhete = PegaBilhete();

    if (idx > -1) {
      bilhete.splice(idx, 1, jogo);
    } else {
      bilhete.push(jogo);
    }
    localStorage.bilhete = JSON.stringify(bilhete);
  }

  MontaBilhete();

  $(".modalWindow2, .modalBack").fadeOut('fast');
  $('body').removeClass('noscroll');
}

function removeLive(hasLive) {
  const bilhete = PegaBilhete();
  const has = false;

  for (let i = 0; i < bilhete.length; i++) {
    if (bilhete[i].aovivo === hasLive) {
      bilhete.splice(i, 1);
      localStorage.bilhete = JSON.stringify(bilhete);
      removeLive(hasLive);
    }
  }

  if (has) {
    MontaBilhete();
  }
}

function ConsultarOddLocal(campJogId, JogOddId) {
  removeLive(true);
  let idx = PegaIndexOddPorJogId(JogOddId);

  if (idx > -1) {
    let bilhete = PegaBilhete();

    bilhete.splice(idx, 1);
    localStorage.bilhete = JSON.stringify(bilhete);
    MontaBilhete();
    return;
  }

  let jogoLocal = ProcurarJogoLocal(campJogId);
  let nomes = "";

  if (jogoLocal !== undefined) {

    let idxOdd = -1;
    let Odds;

    if (localStorage.EsporteId === '101'
      || localStorage.EsporteId === '102') {
      let d = JsonStrToDate(jogoLocal.DT_INI);
      nomes = "<b>" + jogoLocal.TIME_NOME + "</b><br />"
        + d.toLocaleDateString("pt-BR", {
          day: '2-digit',
          month: '2-digit',
          year: '2-digit',
          hour: '2-digit',
          minute: '2-digit'
        });

      idxOdd = -1;
      Odds = jogoLocal.Odds;
      for (let i = 0; i < Odds.length; i++) {
        if (Odds[i].ID === JogOddId) {
          idxOdd = i;
          break;
        }
      }
    } else {
      let d = JsonStrToDate(jogoLocal.dt_hr_ini);
      nomes = "<b>" + jogoLocal.casa_time + "</b> x <b>"
        + jogoLocal.visit_time + "</b><br />"
        + d.toLocaleDateString("pt-BR", {
          day: '2-digit',
          month: '2-digit',
          year: '2-digit',
          hour: '2-digit',
          minute: '2-digit'
        });

      idxOdd = -1;
      Odds = jogoLocal.Odds;
      for (let i = 0; i < Odds.length; i++) {
        if (Odds[i].jog_odd_id === JogOddId) {
          idxOdd = i;
          break;
        }
      }

      if (idxOdd === -1 && maisOdds !== undefined) {
        Odds = maisOdds;
        for (let i = 0; i < Odds.length; i++) {
          if (Odds[i].jog_odd_id === JogOddId) {
            idxOdd = i;
            break;
          }
        }
      }
    }

    let jogo = {
      jog_odd_id: JogOddId,
      esporte_id: localStorage.EsporteId,
      camp_jog_id: campJogId,
      descricao: Odds[idxOdd].descricao ? Odds[idxOdd].descricao
        : Odds[idxOdd].DESCRICAO,
      taxa: Odds[idxOdd].taxa ? Odds[idxOdd].taxa : Odds[idxOdd].TAXA,
      nomeTimes: nomes,
      inicio: jogoLocal.dt_hr_ini || jogoLocal.DT_INI,
      aovivo: false
    };

    idx = PegaIndexOddPorCampJogId(campJogId);

    let bilhete = PegaBilhete();

    if (idx > -1) {
      bilhete.splice(idx, 1, jogo);
    } else {
      bilhete.push(jogo);
    }

    localStorage.bilhete = JSON.stringify(bilhete);

  }

  MontaBilhete();
}

window.CheckOdd = function (id) {
  ConsultarOdd(id);
}

function CheckOdd2(id) {
  $(".modalWindow2, .modalBack").fadeOut('fast');
  $('body').removeClass('noscroll');
  ConsultarOdd(id);
}

function ConsultarOdd(id) {

  var idx = PegaIndexOddPorJogId(id);

  if (idx > -1) {
    var bilhete = PegaBilhete();

    bilhete.splice(idx, 1);
    localStorage.bilhete = JSON.stringify(bilhete);
    MontaBilhete();
    return;
  }

  $.ajax({
    url: url + "/enet/VJogoOdds/" + id,
    type: "GET",
    contentType: "application/json; charset=utf-8",
    dataType: "json",
    processdata: true,
    success: function (data) {
      AddOdd(data);
    },
    error: function (xhr) {
      // alert("Erro 2: " + xhr.statusText);
      return null;
    }
  });
}

function PegaBilhete() {
  var b = [];

  if (localStorage.bilhete) {
    if (localStorage.bilhete !== undefined && localStorage.bilhete !== "")
      try {
        b = JSON.parse(localStorage.bilhete);
      } catch (ex) {/**/
      }
  }
  return b;
}

function PegaIndexOddPorJogId(id) {
  const bilhete = PegaBilhete();

  for (let i = 0; i < bilhete.length; i++) {
    if (bilhete[i].jog_odd_id === id) {
      return i;
    }
  }

  return -1;
}

function PegaIndexOddPorCampJogId(id) {
  const bilhete = PegaBilhete();

  for (let i = 0; i < bilhete.length; i++) {
    if (bilhete[i].camp_jog_id === id) {
      return i;
    }
  }

  return -1;
}

function ProcurarJogoLocal(campJogId) {
  if (localStorage.EsporteId === '101' || localStorage.EsporteId === '102') {
    for (let i = 0; i < listaJogos.length; i++) {
      for (let p = 0; p < listaJogos[i].PARTICIPANTES.length; p++) {
        if (listaJogos[i].PARTICIPANTES[p].ID === campJogId) {
          let tmp = listaJogos[i].PARTICIPANTES[p];
          tmp.DT_INI = listaJogos[i].DT_INI;
          return tmp;
        }
      }
    }
  } else {
    for (let i = 0; i < listaJogos.length; i++) {
      if (listaJogos[i].camp_jog_id === campJogId) {
        return listaJogos[i];
      }
    }
  }

  return undefined;
}

function AddOdd(data) {

  var jogoLocal = ProcurarJogoLocal(data.camp_jog_id);

  var nomes = "";

  if (jogoLocal !== undefined) {
    var d = JsonStrToDate(jogoLocal.dt_hr_ini);

    nomes = "<b>" + jogoLocal.casa_time + "</b> x <b>"
      + jogoLocal.visit_time + "</b><br />"
      + d.toLocaleDateString("pt-BR", {
        day: '2-digit',
        month: '2-digit',
        year: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      });
  }

  var jogo = {
    jog_odd_id: data.jog_odd_id,
    esporte_id: localStorage.EsporteId,
    camp_jog_id: data.camp_jog_id,
    descricao: data.descricao,
    taxa: data.taxa,
    nomeTimes: nomes,
    inicio: jogoLocal !== undefined ? jogoLocal.dt_hr_ini : undefined
  };

  var idx = PegaIndexOddPorCampJogId(data.camp_jog_id);

  var bilhete = PegaBilhete();

  if (idx > -1) {
    bilhete.splice(idx, 1, jogo);
  } else {
    bilhete.push(jogo);
  }

  localStorage.bilhete = JSON.stringify(bilhete);

  MontaBilhete();
}

// ── Bet Builder ────────────────────────────────────────────────────────────

window.toggleBetBuilder = function () {
  betBuilderMode = document.getElementById('bbToggle').checked;
  betBuilderLegs = [];
  $('#bbHeaderSub').text(betBuilderMode ? 'Criar Aposta ativado' : 'Criar Aposta desativado');
  $('#bbFooter').toggle(betBuilderMode);
  $('[data-jog-odd-id]').removeClass('bb-selected');

  if (betBuilderMode) {
    // Entrar no modo já pergunta ao servidor o que é elegível neste jogo.
    bbRefresh();
  } else {
    bbResetState();
    updateBBUI();
  }
};

function selectBBLeg(jog_odd_id) {
  const odd = maisOdds.find(function(o) { return o.jog_odd_id === jog_odd_id; });
  if (!odd || bbState.carregando) return;

  // Desmarcar é sempre permitido e nunca pode falhar: tira a perna e reconsulta,
  // porque o que passa a ser combinável muda junto.
  const idx = betBuilderLegs.findIndex(function(l) { return l.jog_odd_id === jog_odd_id; });
  if (idx > -1) {
    betBuilderLegs.splice(idx, 1);
    bbRefresh();
    return;
  }

  if (!bbState.elegiveis[jog_odd_id]) {
    alert('Este mercado não está disponível no Criar Aposta.');
    return;
  }
  if (bbState.bloqueadas[jog_odd_id]) {
    // A odd bloqueada fica oculta; chegar aqui é o toque que correu com a
    // resposta. Mostra o motivo que veio do servidor em vez de ignorar calado.
    alert(bbState.bloqueadas[jog_odd_id].texto);
    return;
  }
  if (betBuilderLegs.length >= bbState.maxLegs) {
    alert('Máximo de ' + bbState.maxLegs + ' seleções por Criar Aposta.');
    return;
  }

  const nova = {
    jog_odd_id: odd.jog_odd_id,
    taxa: odd.taxa,
    descricao: odd.descricao,
    categoria_id: odd.categoria_id,
    odd_tipo: odd.odd_tipo,
    camp_jog_id: odd.camp_jog_id
  };
  betBuilderLegs.push(nova);

  // Otimista na tela, confirmado no servidor: se a chamada falhar, a perna volta
  // atrás. Bloquear o toque é o certo — liberar por falta de resposta é o bug
  // que a unificação veio resolver.
  bbRefresh(null, function () {
    betBuilderLegs = betBuilderLegs.filter(function (l) { return l.jog_odd_id !== nova.jog_odd_id; });
    updateBBUI();
    alert('Não foi possível validar a combinação. Tente novamente.');
  });
}

function updateBBUI() {
  $('[data-jog-odd-id]').removeClass('bb-selected');
  betBuilderLegs.forEach(function(leg) {
    $('[data-jog-odd-id="' + leg.jog_odd_id + '"]').addClass('bb-selected');
  });

  applyBBVisibility();

  const count = betBuilderLegs.length;
  if (count === 0) {
    $('#bbOddDisplay').text('-');
    $('#bbLegsList').html('<em style="color:#999">Selecione ' + bbState.minLegs + ' a ' + bbState.maxLegs + ' odds</em>');
    $('#bbAddBtn').prop('disabled', true);
    return;
  }

  let legItems = betBuilderLegs.map(function(l) {
    return "<div class='bb-leg-item'>" + l.descricao
      + " <span>" + l.taxa.toLocaleString('pt-BR', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + "</span></div>";
  }).join('');

  $('#bbLegsList').html(legItems);
  // A odd combinada vem pronta do servidor — é a mesma que o bilhete vai gravar.
  // Calcular aqui de novo era outra chance de divergir (cada front tinha a sua
  // cópia da tabela de deságio).
  $('#bbOddDisplay').text(
    bbState.oddCombinada
      ? bbState.oddCombinada.toLocaleString('pt-BR', {minimumFractionDigits: 2, maximumFractionDigits: 2})
      : '-'
  );
  $('#bbAddBtn').prop('disabled', !bbState.valido);
}

window.adicionarBBaoBilhete = function () {
  // O botão só habilita com valido = true, que é o veredito do servidor.
  if (!bbState.valido || !bbState.oddCombinada) return;

  const combinedOdd = bbState.oddCombinada;

  let bilhete = PegaBilhete();
  const existingIdx = bilhete.findIndex(function(j) { return j.camp_jog_id === betBuilderJogoId; });
  if (existingIdx > -1) bilhete.splice(existingIdx, 1);

  bilhete.push({
    jog_odd_id: null,
    esporte_id: localStorage.EsporteId,
    camp_jog_id: betBuilderJogoId,
    descricao: betBuilderLegs.map(function(l) { return l.descricao; }).join(' + '),
    taxa: combinedOdd,
    nomeTimes: betBuilderNomeTimes,
    inicio: (ProcurarJogoLocal(betBuilderJogoId) || {}).dt_hr_ini,
    aovivo: false,
    betBuilder: true,
    legs: betBuilderLegs.map(function(l) { return l.jog_odd_id; })
  });

  localStorage.bilhete = JSON.stringify(bilhete);

  betBuilderMode = false;
  betBuilderLegs = [];
  bbResetState();

  $(".modalWindow2, .modalBack").fadeOut('fast');
  $('body').removeClass('noscroll');

  MontaBilhete();
};

window.RemoveBBItem = function (campJogId) {
  let bilhete = PegaBilhete();
  const idx = bilhete.findIndex(function(j) { return j.betBuilder && j.camp_jog_id === campJogId; });
  if (idx > -1) {
    bilhete.splice(idx, 1);
    localStorage.bilhete = JSON.stringify(bilhete);
    MontaBilhete();
  }
};

// ────────────────────────────────────────────────────────────────────────────

function AtualizarOddsAtivas() {
  $("[data-jog-odd-id]").removeClass("odd-ativa");
  const bilhete = PegaBilhete();
  for (let i = 0; i < bilhete.length; i++) {
    $("[data-jog-odd-id='" + bilhete[i].jog_odd_id + "']").addClass("odd-ativa");
  }
}

// Pré-jogo cujo horário já passou. O ao vivo começou por definição e não é marcado.
function JaComecou(item) {
  if (item.aovivo || !item.inicio) {
    return false;
  }
  const d = JsonStrToDate(item.inicio);
  return d !== undefined && d <= new Date();
}

function DataHoraCurta(d) {
  return d.toLocaleDateString("pt-BR", {
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  });
}

// Mesmo fluxo do "Copiar Bilhete" do app: o cupom recebe as seleções que ainda
// valem, já com a cotação de agora, e a página de apostas abre com nome e valor
// do bilhete. A consulta é outra página, então o resto segue pelo localStorage
// (bilheteCopia), que a página de apostas lê em AplicarCopiaBilhete.
window.CopiarBilhete = function (codigo) {
  avisoAguarde();
  $.ajax({
    url: url + "axios/carregarBilhete/" + encodeURIComponent(codigo),
    type: "GET",
    dataType: "json",
    success: function (data) {
      retirarAguarde();
      if (data.result !== "success") {
        alert(data.message || "Bilhete não encontrado.");
        return;
      }
      if (data.itens.length === 0) {
        alert("Nenhum jogo deste bilhete está disponível.");
        return;
      }
      const bilhete = data.itens.map(function (item) {
        const g = item.game;
        const d = JsonStrToDate(g.data_hora);
        const jogo = {
          jog_odd_id: item.betBuilder ? null : item.odd_id,
          esporte_id: localStorage.EsporteId,
          camp_jog_id: g.id,
          descricao: item.betBuilder
            ? item.legs.map(function (l) { return l.odds; }).join(' + ')
            : item.odd,
          taxa: parseFloat(item.taxa),
          nomeTimes: "<b>" + g.tc + "</b> x <b>" + g.tf + "</b><br />" + (d ? DataHoraCurta(d) : ""),
          inicio: g.data_hora,
          aovivo: false
        };
        if (item.betBuilder) {
          jogo.betBuilder = true;
          jogo.legs = item.legs.map(function (l) { return l.id; });
        }
        return jogo;
      });
      localStorage.bilhete = JSON.stringify(bilhete);
      localStorage.bilheteCopia = JSON.stringify({
        cliente: data.cliente,
        valor: data.valor,
        ficaram: data.iniciados + data.indisponiveis
      });
      if ($("#EditVlAposta").length) {
        AplicarCopiaBilhete();
      } else {
        location.href = url;
      }
    },
    error: function () {
      retirarAguarde();
      alert("Ocorreu um erro, tente novamente!");
    }
  });
};

export function AplicarCopiaBilhete() {
  let copia;
  try {
    copia = JSON.parse(localStorage.bilheteCopia || "null");
  } catch (e) {/**/
  }
  localStorage.removeItem("bilheteCopia");
  if (!copia) {
    return;
  }
  $("#EditCliente").val(copia.cliente || "");
  $("#EditVlAposta").val(String(copia.valor || "").replace(".", ","));
  MontaBilhete();
  // O alert/confirm só depois de a página desenhar o cupom.
  setTimeout(function () {
    const titulo = copia.ficaram > 0
      ? "Jogos disponíveis foram copiados (" + copia.ficaram + (copia.ficaram === 1 ? " ficou" : " ficaram") + " de fora)."
      : "Todos os jogos foram copiados.";
    if (confirm(titulo + "\n\nDeseja confirmar a aposta com o mesmo nome e valor?")) {
      window.Confirmar();
    }
  }, 300);
}

export function MontaBilhete() {
  window.divBilhete.html("");
  window.lbNjogos.html('');

  const bilhete = PegaBilhete();

  if (bilhete.length > 0) {

    let table = "<table class='tabelaBilhete  ' border='0' cellpadding='2' cellspacing='2'>{0}</table>";

    let row = "<tr {class}><td>{nomeTimes}</td><td width='10%'>{link}</td></tr>";

    let linhas = row.replace("{class}", "class='tabelaBilheteTitulo'")
      .replace("{nomeTimes}", "Jogos").replace("{link}", "&nbsp;");

    let css = "";
    for (let i = 0; i < bilhete.length; i++) {
      if (i % 2 === 0)
        css = "class='tabelaBilheteTituloLinhaImpar'";
      else
        css = "";

      let descricao = bilhete[i].nomeTimes;
      if (JaComecou(bilhete[i])) {
        descricao += " <span style='background:#f39c12;color:#fff;padding:0 4px;border-radius:3px;font-size:10px;font-weight:bold'>Já começou</span>";
      }
      if (bilhete[i].betBuilder) {
        try {
          let taxa_str = bilhete[i].taxa.toLocaleString('pt-BR', {
            minimumFractionDigits: '2',
            maximumFractionDigits: '2'
          });
          descricao += "<br />Criar Aposta: " + bilhete[i].descricao + " - Taxa: " + taxa_str;
        } catch (err) {
          window.RemoveBBItem(bilhete[i].camp_jog_id);
        }
        linhas += row.replace("{class}", css).replace("{nomeTimes}", descricao)
          .replace("{link}", "<a href='javascript:window.RemoveBBItem(" + bilhete[i].camp_jog_id + ");'>Excluir</a>");
      } else {
        try {
          descricao += "<br />Vencedor: " + bilhete[i].descricao
            + " - Taxa: " + bilhete[i].taxa.toLocaleString('pt-BR', {
              minimumFractionDigits: '2',
              maximumFractionDigits: '2'
            });
        } catch (err) {
          window.CheckOdd(bilhete[i].jog_odd_id);
        }
        if (bilhete[i].aovivo) {
          linhas += row.replace("{class}", css).replace("{nomeTimes}",
            descricao).replace(
            "{link}",
            "<a href='javascript:window.RemoveOddLive(" + bilhete[i].camp_jog_id
            + ");'>Excluir</a>");
        } else {
          linhas += row.replace("{class}", css).replace("{nomeTimes}",
            descricao).replace(
            "{link}",
            "<a href='javascript:window.CheckOdd(" + bilhete[i].jog_odd_id
            + ");'>Excluir</a>");
        }
      }
    }

    window.divBilhete.append(table.replace("{0}", linhas));

    window.lbNjogos.html(bilhete.length);
  }

  window.CalcularGanho();
  AtualizarOddsAtivas();
}

// SuperMúltipla: cada item do bilhete vale UM evento e só conta para o bônus
// quando sua odd atinge a odd mínima; os demais continuam no bilhete, apenas não
// somam percentual. Ao vivo fica de fora, que ainda não entra na promoção.
//
// Espelha SuperMultiplaConfig::bonus no backend: abaixo do mínimo de eventos não
// há bônus, e acima da maior faixa da grade vale o último valor definido.
window.SuperMultiplaBonus = function (bilhete) {
  var c = window.config;
  if (!c || !c.supermultipla_ativo || !c.supermultipla_grade) {
    return 0;
  }
  if (!bilhete || bilhete.length === 0) {
    return 0;
  }
  if (bilhete.some(function (i) { return i.aovivo; })) {
    return 0;
  }
  var min = parseFloat(c.supermultipla_odd_minima) || 0;
  var n = bilhete.filter(function (i) { return parseFloat(i.taxa) >= min; }).length;
  if (n < (parseInt(c.supermultipla_min_eventos) || 0)) {
    return 0;
  }
  var chaves = Object.keys(c.supermultipla_grade).map(Number).sort(function (a, b) { return a - b; });
  var chave = chaves.filter(function (k) { return k <= n; }).pop();
  if (chave === undefined) {
    return 0;
  }
  return (parseFloat(c.supermultipla_grade[chave]) || 0) / 100;
};

// Tetos de prêmio do tenant, na ordem em que o backend aplica.
function aplicaTetosPremio(vlPremio, vlAposta) {
  if (window.config.Vl_Max_Premio_Fut > 0
      && vlPremio > window.config.Vl_Max_Premio_Fut
      && window.config.Acao_Prem_Max === 1) {
    vlPremio = window.config.Vl_Max_Premio_Fut;
  }
  if (window.config.Multiplic_Max_Premio > 0 && window.config.Acao_Prem_Max === 1) {
    var vlMultiplicado = parseFloat((vlAposta * window.config.Multiplic_Max_Premio).toFixed(2));
    if (vlPremio > vlMultiplicado) {
      vlPremio = vlMultiplicado;
    }
  }
  return vlPremio;
}

function fmtMoeda(v) {
  return v.toLocaleString('pt-BR', {minimumFractionDigits: 2, maximumFractionDigits: 2});
}

// Selo da SuperMúltipla. O valor em R$ só entra quando já há valor apostado —
// antes disso o percentual sozinho já informa o apostador.
function atualizaSeloSuperMultipla(bonus, valorBonus) {
  var $selo = $("#lbSuperMultipla");
  if (!$selo.length) {
    return;
  }
  if (bonus <= 0) {
    $selo.hide();
    return;
  }
  var txt = "SuperMúltipla: +"
    + parseFloat((bonus * 100).toFixed(2)).toLocaleString('pt-BR', {maximumFractionDigits: 2})
    + "% na odd total";
  if (valorBonus > 0) {
    txt += " (+" + fmtMoeda(valorBonus) + " no prêmio)";
  }
  $selo.html(txt).show();
}

window.CalcularGanho = function () {
  $("#lbVlPremio").html("0,00");
  $("#lbVlTaxaTotal").html("0,00");

  var vlPremio = 1;
  var vlAposta = 0;

  // O selo depende só das seleções, então é atualizado antes da checagem de valor
  // — aparece assim que o bilhete atinge os eventos elegíveis. Se houver valor
  // apostado, é reescrito abaixo já com o ganho em R$.
  var bonusSM = window.SuperMultiplaBonus(PegaBilhete());
  atualizaSeloSuperMultipla(bonusSM, 0);

  try {
    vlAposta = parseFloat($("#EditVlAposta").val().replace(",", "."));
  } catch (ex) {/**/
  }

  if (vlAposta > 0) {
    var bilhete = PegaBilhete();

    if (bilhete.length > 0) {

      for (let i = 0; i < bilhete.length; i++) {
        vlPremio *= bilhete[i].taxa;
      }


      var oddBase = parseFloat(vlPremio.toFixed(2));

      // O bônus é aplicado sobre o produto JÁ ARREDONDADO, que é o que o servidor
      // faz em getBilhete (round(produto,2) e só então o aumento). Aplicar sobre o
      // produto cheio dava 1 centavo a mais que o valor realmente gravado.
      //
      // Entra ANTES dos tetos, igual ao backend: o aumento é turbinado mas o
      // prêmio máximo do tenant continua valendo por cima dele.
      var vlTaxaTotal = bonusSM > 0
        ? parseFloat((oddBase * (1 + bonusSM)).toFixed(2))
        : oddBase;

      vlPremio = (oddBase === 1) ? 0 : vlTaxaTotal;

      vlPremio = aplicaTetosPremio(parseFloat((vlPremio * vlAposta).toFixed(2)), vlAposta);

      // Ganho da promoção = prêmio com bônus menos prêmio sem, os dois já com os
      // tetos aplicados. Se o teto comeu o aumento, o valor sai 0 — que é o que o
      // apostador realmente leva.
      if (bonusSM > 0) {
        var premioSemBonus = aplicaTetosPremio(
          parseFloat(((oddBase === 1 ? 0 : oddBase) * vlAposta).toFixed(2)),
          vlAposta
        );
        atualizaSeloSuperMultipla(bonusSM, Math.max(0, parseFloat((vlPremio - premioSemBonus).toFixed(2))));
      }

      $("#lbVlPremio").html(vlPremio.toLocaleString('pt-BR', {
        minimumFractionDigits: '2',
        maximumFractionDigits: '2'
      }));

      $("#lbVlTaxaTotal").html(vlTaxaTotal.toLocaleString('pt-BR', {
        minimumFractionDigits: '2',
        maximumFractionDigits: '2'
      }));

      return vlPremio;
    }
  }
  return 0;
}

window.Confirmar = function () {

  var vlAposta = 0;
  try {
    vlAposta = parseFloat($("#EditVlAposta").val().replace(",", "."));
  } catch (ex) {/**/
  }

  var bilhete = PegaBilhete();

  if (bilhete.length > 0) {

    if (vlAposta > 0) {

      let vlPremio = CalcularGanho();

      if (window.config) {
        var aovivo = bilhete[0].aovivo;
        if (!aovivo) {
          if (window.config.N_Min_Jogos > 0) {
            if (bilhete.length < window.config.N_Min_Jogos) {
              alert("O número mínimo de jogos por aposta é de "
                + window.config.N_Min_Jogos);
              return;
            }
          }

          if (window.config.N_Max_Jogos > 0) {
            if (bilhete.length > window.config.N_Max_Jogos) {
              alert("O limite máximo de jogos por aposta é de "
                + window.config.N_Max_Jogos);
              return;
            }
          }

          if (window.config.Vl_Min_Apost_Fut > 0) {
            if (vlAposta < window.config.Vl_Min_Apost_Fut) {
              alert("O valor mínimo de aposta deve ser de "
                + window.config.Vl_Min_Apost_Fut.toLocaleString(
                  'pt-BR', {
                    minimumFractionDigits: '2',
                    maximumFractionDigits: '2'
                  }));
              return;
            }
          }

          if (window.config.Vl_Max_Apost_Fut > 0) {
            if (vlAposta > window.config.Vl_Max_Apost_Fut) {
              alert("O valor máximo de aposta permitido é de "
                + window.config.Vl_Max_Apost_Fut.toLocaleString(
                  'pt-BR', {
                    minimumFractionDigits: '2',
                    maximumFractionDigits: '2'
                  }));
              return;
            }
          }

          if (window.config.Vl_Max_Premio_Fut > 0) {
            if (vlPremio > window.config.Vl_Max_Premio_Fut) {
              alert("Não permitido. O valor do prêmio líquido não deve ultrapassar "
                + window.config.Vl_Max_Premio_Fut.toLocaleString(
                  'pt-BR', {
                    minimumFractionDigits: '2',
                    maximumFractionDigits: '2'
                  }));
              return;
            }
          }

          if (window.config.Multiplic_Max_Premio > 0) {
            var vlMultiplicado = vlAposta
              * window.config.Multiplic_Max_Premio;

            if (vlPremio > vlMultiplicado) {
              alert("Não permitido. O valor do prêmio líquido para este valor de aposta não deve ultrapassar "
                + vlMultiplicado.toLocaleString('pt-BR', {
                  minimumFractionDigits: '2',
                  maximumFractionDigits: '2'
                }));
              return;
            }
          }

          if (window.config.Taxa_Minima_Simples > 0) {
            if (bilhete.length == 1 && vlAposta * window.config.Taxa_Minima_Simples > vlPremio) {
              alert("A taxa mínima para apostas simples é de "
                + window.config.Taxa_Minima_Simples);
              return;
            }
          }

          if (window.config.Taxa_Minima_Multipla > 0) {
            if (bilhete.length > 1 && vlAposta * window.config.Taxa_Minima_Multipla > vlPremio) {
              alert("A taxa mínima para apostas multiplas é de "
                + window.config.Taxa_Minima_Multipla);
              return;
            }
          }
        }

        var perguntaTxt = 'Deseja realmente confirmar esta aposta?';
        if (!window.config.Auth.LOGIN)
          perguntaTxt = 'Deseja salvar este pré-bilhete agora?';

        if (confirm(perguntaTxt)) {
          const hasBB = bilhete.some(function(j) { return j.betBuilder; });

          if (hasBB) {
            var bbItems = bilhete.map(function(j) {
              if (j.betBuilder) {
                return { jogo_id: j.camp_jog_id, legs: j.legs };
              }
              return { jogo_id: j.camp_jog_id, odd_id: j.jog_odd_id };
            });
            var dadosStr = JSON.stringify({
              valor: vlAposta,
              cliente: $("#EditCliente").val(),
              fonte: 'enet',
              items: bbItems
            });

            $("#btConfirmar").prop("disabled", "disabled");
            avisoAguarde();

            $.ajax({
              type: "POST",
              url: url + "axios/betBuilder",
              contentType: "application/json; charset=utf-8",
              dataType: "json",
              processdata: true,
              data: dadosStr,
              statusCode: {
                200: function (xhr) {
                  $("#btConfirmar").prop("disabled", "");
                  window.SaldoUser();
                  retirarAguarde();
                  if (xhr.code) {
                    $("#premsg").html('');
                    var p = "";
                    if (window.config.Auth.LOGIN) {
                      p = "<button type=\"button\" onclick=\"javascript: Imprimir('" + xhr.code + "');\" style=\"width: 120px;\">Imprimir</button>";
                    }
                    $("#linkzap").html(
                      "Código " + xhr.code
                      + (xhr.prebilhete ? " (pré-bilhete)" : "")
                      + "<br><a href=\"whatsapp://send?text=" + (xhr.prebilhete ? "Pré-bilhete" : "Bilhete") + "\n "
                      + xhr.code + " " + url + "home/bilhete/" + xhr.code
                      + "\">Compartilhar pelo Whatsapp</a><br>" + p);
                    $("#zapzap").modal();
                    window.Limpar();
                  } else {
                    $("#premsg").html("");
                    $("#linkzap").html(xhr.msg || 'Erro ao processar aposta.');
                    $("#zapzap").modal();
                  }
                }
              },
              error: function (xhr) {
                $("#btConfirmar").prop("disabled", "");
                retirarAguarde();
                tratarErro("Salvar bilhete:", xhr);
              }
            });
          } else {
            var DadosBilhete = {
              NomeCli: $("#EditCliente").val(),
              Origem: 5,
              VlAposta: vlAposta,
              jogos: bilhete
            };

            var dadosStr = JSON.stringify(DadosBilhete);

            $("#btConfirmar").prop("disabled", "disabled");
            avisoAguarde();

            $
              .ajax({
                type: "POST",
                url: url + "enet/PreBilhete",
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                processdata: true,
                data: dadosStr,
                statusCode: {
                  200: function (xhr) {
                    $("#btConfirmar").prop("disabled", "");

                    window.SaldoUser();
                    retirarAguarde();
                    if (xhr.codigo > 0) {
                      $("#premsg").html(xhr.msg);

                      var p = "";
                      if (window.config.Auth.LOGIN) {
                        p = "<button type=\"button\" onclick=\"javascript: Imprimir('" + xhr.codigo + "-" + xhr.dv + "');\" style=\"width: 120px;\">Imprimir</button>";
                      }

                      $("#linkzap")
                        .html(
                          "Código "
                          + xhr.codigo + xhr.dv
                          // Com sessão o enet/prebilhete já confirma o bilhete.
                          + "<br><a href=\"whatsapp://send?text=" + (window.config.Auth.LOGIN ? "Bilhete" : "Pré-bilhete") + "\n "
                          + xhr.codigo + xhr.dv
                          + " " + url + "home/bilhete/" + xhr.codigo + xhr.dv
                          + "\">Compartilhar pelo Whatsapp</a><br>" + p);
                      $("#zapzap").modal();
                      window.Limpar();
                    } else {
                      $("#premsg").html("");
                      $("#linkzap").html(xhr.msg);
                      $("#zapzap").modal();
                    }
                  }
                },
                error: function (xhr) {
                  $("#btConfirmar").prop("disabled", "");

                  retirarAguarde();
                  tratarErro("Salvar bilhete:", xhr);
                }
              });
          }

        }// confirm
      }

    } else
      alert("Informe o valor.");
  } else
    alert("Escolha algum jogo antes de prosseguir.");

}

window.Limpar = function () {
  localStorage.removeItem("bilhete");
  $("#EditVlAposta").val('');
  $("#EditCliente").val('');
  window.lbNjogos.html('');

  MontaBilhete();
}

function ConfirmarPreBilhete() {

  if (window.config.Auth.ID) {
    var codTmp = $("#ContentPlaceHolder1_txtPesq").val();

    if (!codTmp) {
      var codTmp = $("#txtCodigo").val();
    }

    if (codTmp.length > 0) {


      if (window.config) {
        var perguntaTxt = 'Tem certeza que deseja confirmar este pré-bilhete?';

        if (confirm(perguntaTxt)) {
          var DadosPreBilheteModel = {
            ID: 0,
            Codigo: codTmp,
            Origem: 5
          };

          var dadosStr = JSON.stringify(DadosPreBilheteModel);

          avisoAguarde();

          $
            .ajax({
              type: "POST",
              url: url + "enet/PreBilhete/",
              contentType: "application/json; charset=utf-8",
              dataType: "json",
              processdata: true,
              data: dadosStr,
              statusCode: {
                200: function (xhr) {
                  // SaldoUser();
                  retirarAguarde();
                  window
                    .open("./jogos/imp.aspx?cod="
                      + xhr.Codigo,
                      "popup_window",
                      "height = 450 , width = 350, resizable = no, scrollbars = yes, location = no");
                  window.Limpar();
                  location.reload();
                }
              },
              error: function (xhr) {
                retirarAguarde();
                tratarErro("Salvar bilhete:", xhr);
              }
            });

        }// confirm
      }

    } else
      alert("Informe o código do pré-bilhete.");
  } else
    alert("É necessário fazer login.");
}
